/**
 * `contacts` — le carnet (base galerie, 4.1).
 */
import { z } from 'zod';
import { adresseSchema, CHAMPS_DOCUMENT, emailSchema, idSchema, langueSchema, withAudit, } from './commun.js';
export const TYPES_CONTACT = [
    'collectionneur',
    'institution',
    'presse',
    'artiste',
    'transporteur',
    'fournisseur',
];
/**
 * Un type de contact est un code : l'un des six fixes, ou celui d'un type
 * ajouté par la galerie (`perso-…`, ARTO-199). Seule la galerie sait quels
 * codes personnalisés existent ; l'API le vérifie à l'écriture.
 */
export const PREFIXE_TYPE_PERSO = 'perso-';
export const typeContactSchema = z.string().min(1).max(60);
export function estTypeContactFixe(code) {
    return TYPES_CONTACT.includes(code);
}
/** Code stable d'un type personnalisé, tiré de son libellé à la création. */
export function codeTypeContactPerso(libelle) {
    const slug = libelle
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40);
    return `${PREFIXE_TYPE_PERSO}${slug === '' ? 'type' : slug}`;
}
export const typeContactPersoCreationSchema = z.strictObject({
    libelle: z.string().trim().min(1, 'Le nom du type est obligatoire.').max(60),
});
/** D'où le contact est entré dans le carnet. */
export const ORIGINES_CONTACT = [
    'regie',
    'site',
    'import',
    'viewing_room',
    'catalogue_visite',
    'prise_rendez_vous',
    'evenement',
];
export const origineContactSchema = z.enum(ORIGINES_CONTACT);
/** Consentement à la lettre d'information, horodaté et sourcé (6.3). */
export const consentementSchema = z.object({
    accorde: z.boolean().default(false),
    date: z.date().optional(),
    source: origineContactSchema.optional(),
    retireLe: z.date().optional(),
});
export const contactSchema = withAudit(z.object({
    _id: idSchema,
    genre: z.enum(['personne', 'organisation']).default('personne'),
    nom: z.string().min(1),
    prenom: z.string().optional(),
    raisonSociale: z.string().optional(),
    type: typeContactSchema.default('collectionneur'),
    adresses: z.array(adresseSchema).default([]),
    emails: z.array(emailSchema).default([]),
    telephones: z.array(z.string()).default([]),
    langue: langueSchema.default('fr'),
    numeroTvaIntracom: z.string().optional(),
    consentementNewsletter: consentementSchema,
    notes: z.string().optional(),
    etiquettes: z.array(z.string()).default([]),
    origine: origineContactSchema.default('regie'),
    /** Anonymisé au titre du RGPD (7.7) : les factures restent, pas l'identité. */
    anonymiseLe: z.date().optional(),
}));
export const contactCreationSchema = contactSchema.omit({
    ...CHAMPS_DOCUMENT,
    anonymiseLe: true,
});
export const contactMiseAJourSchema = contactCreationSchema.partial();
//# sourceMappingURL=contacts.js.map